<div class="representative-list-component-root">
  <div *ngFor="let item of generalizedRepresentativeList">
    <app-representative-item [expiredTip]="expiredTip"
                             [generalizedRepresentative]="item"
                             [labels]="labels"
                             (promote)="doPromote($event)"
                             (remove)="doRemove($event)"
                             (resendInvite)="doResendInvite($event)"
                             [canTamper]="canTamper"
                             [isSummary]="isSummary"
                             [isSingleAdmin]="isSingleAdmin">
    </app-representative-item>
  </div>
  <div *ngIf="generalizedRepresentativeList?.length === 0" class="no-representatives">
    <nb-icon class="delete-person-icon" icon="person-delete-outline"></nb-icon>
    <span class="no-representative-label">{{labels.representativeNotFound}}</span>
  </div>
</div>
